import React from "react";
import { Typography, Button, Container, useMediaQuery, useTheme } from "@mui/material";
import { CircleUserRound } from 'lucide-react'
import "../CSS/HomeTestimonialCard.css"

const HomeTestimonialCard = ({ image, name, comments }) => {



    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile

    return (
        <div className="testimonial-base-card">
            <div className="profile-pic">
                <CircleUserRound size={40} color="#3DA8A9" />
                {isMobile && (
                    <Typography sx={{ fontSize: 13, mx: '10px' }} variant="body1">
                        {name}
                    </Typography>
                )}
            </div>
            <div className="testimonial-details">
                {!isMobile && (
                    <Typography sx={{ fontSize: 14 }} variant="body1">
                        {name}
                    </Typography>
                )}
                <Typography
                    sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        fontSize: isMobile ? 13 : 14
                    }}
                    variant="body2" color="text.secondary"
                >
                    {comments}
                </Typography>
            </div>
        </div>
    );
};

export default HomeTestimonialCard;